import React, {forwardRef} from 'react';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

import type {ComponentPropsWithoutRef} from 'react';


export type NativeLabelProps = Omit<ComponentPropsWithoutRef<'label'>, 'title'>;

export interface LabelBaseProps extends NativeLabelProps {
    /**
     * When `true` (default), wraps children in `EllipsisTextHint` to truncate
     * overflowing text and show a tooltip. When `false`, children are rendered
     * without any truncation wrapper.
     */
    ellipsis?: boolean,
    /**
     * Tooltip text shown on hover when `ellipsis` is `true`. When omitted, the
     * `EllipsisTextHint` derives the tooltip text from the rendered content.
     */
    title?: string,
}

/**
 * Low-level label primitive that renders a `<label>` element and optionally
 * wraps its children in `EllipsisTextHint` for text overflow handling.
 *
 * Use `Label` for the full-featured label (with root wrapper and `slug` support);
 * use `LabelBase` when you need only the `<label>` element with ellipsis behavior.
 */
export const LabelBase = forwardRef<HTMLLabelElement, LabelBaseProps>(function LabelBase({
    ellipsis = true,
    title,
    children = '',
    ...props
}, ref) {

    return (

        <label {...props} ref={ref}>
            {ellipsis ? (
                <EllipsisTextHint title={title} isActive={ellipsis}>
                    {children}
                </EllipsisTextHint>
            )
                : children}
        </label>
    );
});

LabelBase.displayName = 'LabelBase';
